import { callCoreApi } from "./coreApi";

const PAYMENT_API_BASE_URL = (process.env.REACT_APP_PAYMENT_API_URL || "").replace(/\/$/, "");

export async function paymentApiFetch(path, options = {}) {
	const {
		method = "GET",
		body = null,
		headers = {},
		credentials = "include",
	} = options;

	const normalizedPath = path.startsWith("/") ? path : `/${path}`;
	const requestHeaders = {
		...(body ? { "Content-Type": "application/json" } : {}),
		...headers,
	};

	const response = await fetch(`${PAYMENT_API_BASE_URL}${normalizedPath}`, {
		method,
		credentials,
		headers: requestHeaders,
		...(body ? { body: JSON.stringify(body) } : {}),
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	if (!response.ok) {
		throw new Error(payload.error || `Payment API request failed (${response.status})`);
	}

	return payload;
}

// exception to call core bc the api is already there but the rest should be dialing to port 8084 
export async function listPaymentClients() {
	const payload = await callCoreApi("/api/admin/clients", { method: "GET" });
	return Array.isArray(payload?.clients) ? payload.clients : [];
}

export async function getPaymentClientById(clientId) {
	const id = Number(clientId);
	if (!Number.isFinite(id) || id <= 0) {
		return null;
	}

	const clients = await listPaymentClients();
	return clients.find((client) => Number(client?.id) === id) || null;
}

export async function createPayment(payload) {
	return paymentApiFetch("/api/payments/link", {
		method: "POST",
		body: payload,
	});
}
